/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

export interface IEquipment {
  id?: string;
  modality?: string | null;
  conversionType?: string | null;
  stationName?: string | null;
  institutionName?: string | null;
  institutionAddress?: string | null;
  institutionalDepartmentName?: string | null;
  manufacturer?: string | null;
  manufacturerModelName?: string | null;
  softwareVersion?: string | null;
  deviceSerialNumber?: string | null;
  microSec?: number | null;
  timestampentry?: number | null;
  lastupdated?: number | null;
  cursor?: number;
  active?: boolean | null;
}

export const defaultValue: Readonly<IEquipment> = {
  active: false,
};
